/**
 * Created by bszggg on 2019. 12. 10..
 */
module.exports = {

    "normal": {

        _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": { key: " ", text: "Space", width: 180},
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": { func: "backspace", classes: "control backspace", width: 65},
            "accept": { func: "accept", text: "Close", classes: "control featured"},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{caps} a s d f g h j k l ; ' {enter}",
            "{shiftl} z x c v b n m , . / {shiftr}",
            "{next} {space} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],
        shifted: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            "{caps} A S D F G H J K L : \" {enter}",
            "{shiftl} Z X C V B N M < > ? {shiftr}",
            "{next} {space} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],

        capsed: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Q W E R T Y U I O P [ ] \\",
            "{caps} A S D F G H J K L ; ' {enter}",
            "{shiftl} Z X C V B N M , . / {shiftr}",
            "{next} {space} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ]
    },
    "normaln": {

        _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": { key: " ", text: "Space", width: 180},
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": { func: "backspace", classes: "control backspace", width: 65},
            "accept": { func: "accept", text: "Close", classes: "control featured"},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{caps} a s d f g h j k l ; ' {enter}",
            "{shiftl} z x c v b n m , . / {shiftr}",
            "{next} {space} {accept} {next}"
            ,'           {cursorleft} {cursorRight}'
        ],
        shifted: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            "{caps} A S D F G H J K L : \" {enter}",
            "{shiftl} Z X C V B N M < > ? {shiftr}",
            "{next} {space} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],

        capsed: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Q W E R T Y U I O P [ ] \\",
            "{caps} A S D F G H J K L ; ' {enter}",
            "{shiftl} Z X C V B N M , . / {shiftr}",
            "{next} {space} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ]
    },

    "compact": {

        _meta: {
            "default": { keySet: "default", text: "abc", classes: "control"},
            "alpha": { keySet: "default", text: "Abc", classes: "control"},
            "shift": { keySet: "shifted", text: "ABC", classes: "control"},
            "numbers": { keySet: "numbers", text: "123", classes: "control"},
            "space": { key: " ", text: "Space", width: 200},
            "backspace": { func: "backspace", classes: "control"},
            "accept": { func: "accept", text: "Close", classes: "control featured"},
            "next": { func: "next", text: "Next", classes: "featured"},
            "zero": { key: "0", width: 130},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        default: [
            "q w e r t y u i o p",
            " a s d f g h j k l ",
            "{shift} z x c v b n m {backspace}",
            "{numbers} , {space} . {next} {accept}"
        ],

        shifted: [
            "Q W E R T Y U I O P",
            " A S D F G H J K L ",
            "{default} Z X C V B N M ",
            "{numbers} _ {space} {backspace} {next} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],

        numbers: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "  {alpha} . {zero} {backspace} {next} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ]
    },

    "numeric": {

        _meta: {
            "backspace": { func: "backspace", classes: "control"},
            "accept": { func: "accept", text: "Close", classes: "control featured"},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "zero": { key: "0", width: 130},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        default: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "_ - . {zero} {backspace} {next} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ]
    },

    'num': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6  ',
            '  1 2 3  ',
            '- 0 00 . {accept}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },

    'numn': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6  ',
            '  1 2 3  ',
            '- 0 00 . {accept}',
            '        {next}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },

    'hunum1': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6  ',
            '  1 2 3  ',
            '- 0 00 . {accept}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },
    'hunum1n': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6  ',
            '  1 2 3  ',
            '- 0 00 . {accept}',
            '        {next}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },
    'nplus': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "nplus": {func: "nplus", text: "N+", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6 {nplus}',
            '  1 2 3  ',
            '- 0 00 . {accept}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },

    'dbplus': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "nplus": {func: "nplus", text: "N+", classes: "control featured"},
            "dbplus": {func: "dbplus", text: "*X", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6  ',
            '  1 2 3 {dbplus}',
            '- 0 00 . {accept}'
            ,'           {cursorleft} {cursorRight}'

        ]

    },
    'ndbplus': {
        '_meta': {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace"}, // , width: 65
            "accept": {func: "accept", text: "Close", classes: "control featured"},
            "nplus": {func: "nplus", text: "N+", classes: "control featured"},
            "dbplus": {func: "dbplus", text: "*X", classes: "control featured"},
            "next": {func: "next", text: "Next", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },

        'default': [
            // '7 8 9',
            // '4 5 6',
            // '1 2 3',
            // '0 00 {bksp}',
            // '{a} . {c}'
            '  7 8 9 {backspace}',
            '  4 5 6 {nplus}',
            '  1 2 3 {dbplus}',
            '- 0 00 . {accept}'
            // '        {cursorleft} {cursorRight} '
            ,'           {cursorleft} {cursorRight}'

        ]

    },
    "hutext1":{

        _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "shiftr": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "alt": { keySet: "alt", text: "Alt", width: 60, classes: "control"},
            "caps": { keySet: "capsed", text: "Caps lock", width: 100, classes: "control"},
            "space": { key: " ", text: "Space", width: 180},
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": { func: "backspace", classes: "control backspace", width: 100},
            "accept": { func: "accept", text: "Close", classes: "control featured accept", width: 100},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "cancel": { func: "cancel", text: "Cancel", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },


        "default": [
            "0 1 2 3 4 5 6 7 8 9 \u00f6 \u00fc \u00f3 {backspace}", // ⌫
            "{tab} q w e r t z u i o p \u0151 \u00fa    ",
            "{caps} a s d f g h j k l \u00e9 \u00e1 \u0171 {accept}",
            "{shiftl} \u00ed y x c v b n m , . - {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ],
        "shifted": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {accept}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ],
        "capsed": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {accept}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ],
        "alt": [
            "  ~ \u02c7 ^ \u02d8 \u00b0 \u02db ` \u02d9 \u00b4 \u02dd \u00a8 \u00b8 {backspace}",
            "{tab} \\ | \u00c4   \u20ac \u00cd {sp:1} {sp:1} \u00f7 \u00d7    ",
            "{caps} \u00e4 \u0111 \u0110 [ ]   \u00ed \u0142 \u0141 $ \u00df \u00a4 {accept}",
            "{shiftl} < > # & @ { } < ; > * {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ]
    },
    "hutext1n":{

        _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "shiftr": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "alt": { keySet: "alt", text: "Alt", width: 60, classes: "control"},
            "caps": { keySet: "capsed", text: "Caps lock", width: 100, classes: "control"},
            "space": { key: " ", text: "Space", width: 180},
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": { func: "backspace", classes: "control backspace", width: 100},
            "accept": { func: "accept", text: "Close", classes: "control featured accept", width: 100},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "cancel": { func: "cancel", text: "Cancel", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },


        "default": [
            "0 1 2 3 4 5 6 7 8 9 \u00f6 \u00fc \u00f3 {backspace}", // ⌫
            "{tab} q w e r t z u i o p \u0151 \u00fa    ",
            "{caps} a s d f g h j k l \u00e9 \u00e1 \u0171 {accept}",
            "{shiftl} \u00ed y x c v b n m , . - {shiftr}",
            "  {alt} {space} {alt} {next}"
            ,'           {cursorleft} {cursorRight}'
        ],
        "shifted": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {accept}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ],
        "capsed": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {accept}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ],
        "alt": [
            "  ~ \u02c7 ^ \u02d8 \u00b0 \u02db ` \u02d9 \u00b4 \u02dd \u00a8 \u00b8 {backspace}",
            "{tab} \\ | \u00c4   \u20ac \u00cd {sp:1} {sp:1} \u00f7 \u00d7    ",
            "{caps} \u00e4 \u0111 \u0110 [ ]   \u00ed \u0142 \u0141 $ \u00df \u00a4 {accept}",
            "{shiftl} < > # & @ { } < ; > * {shiftr}",
            "  {alt} {space} {alt}  "
            ,'           {cursorleft} {cursorRight}'
        ]
    },
    "hutext2":{

        _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "shiftr": { keySet: "shifted", text: "Shift", width: 120, classes: "control"},
            "alt": { keySet: "alt", text: "Alt", width: 60, classes: "control"},
            "caps": { keySet: "capsed", text: "Caps lock", width: 100, classes: "control"},
            "space": { key: " ", text: "Space", width: 180},
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": { func: "backspace", classes: "control backspace", width: 100},
            "accept": { func: "accept", text: "Close", classes: "control featured", width: 100},
            "next": { func: "next", text: "Next", classes: "control featured"},
            "cancel": { func: "cancel", text: "Cancel", classes: "control featured"},
            "cursorleft": { func: "cursorleft", text: "<", classes: "control featured", width: 30},
            "cursorRight": { func: "cursorRight", text: ">", classes: "control featured", width: 30},
        },


        "default": [
            "0 1 2 3 4 5 6 7 8 9 \u00f6 \u00fc \u00f3 {backspace}", // ⌫
            "{tab} q w e r t z u i o p \u0151 \u00fa    ",
            "{caps} a s d f g h j k l \u00e9 \u00e1 \u0171 {enter}",
            "{shiftl} \u00ed y x c v b n m , . - {shiftr}",
            "  {alt} {space} {alt} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],
        "shifted": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {enter}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],
        "capsed": [
            "\u00a7 ' \" + ! % / = ( ) \u00d6 \u00dc \u00d3 {backspace}",
            "{tab} Q W E R T Z U I O P \u0150 \u00da    ",
            "{caps} A S D F G H J K L \u00c9 \u00c1 \u0170 {enter}",
            "{shiftl} \u00cd Y X C V B N M ; : _ {shiftr}",
            "  {alt} {space} {alt} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ],
        "alt": [
            "  ~ \u02c7 ^ \u02d8 \u00b0 \u02db ` \u02d9 \u00b4 \u02dd \u00a8 \u00b8 {backspace}",
            "{tab} \\ | \u00c4   \u20ac \u00cd {sp:1} {sp:1} \u00f7 \u00d7    ",
            "{caps} \u00e4 \u0111 \u0110 [ ]   \u00ed \u0142 \u0141 $ \u00df \u00a4 {enter}",
            "{shiftl} < > # & @ { } < ; > * {shiftr}",
            "  {alt} {space} {alt} {accept}"
            ,'           {cursorleft} {cursorRight}'
        ]
    }


};